import { render } from "./elem-prompt.vue?vue&type=template&id=3920c7b1&ts=true"
import script from "./elem-prompt.vue?vue&type=script&lang=ts"
export * from "./elem-prompt.vue?vue&type=script&lang=ts"

import "./elem-prompt.vue?vue&type=style&index=0&id=3920c7b1&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__